export const TelegramHelpLink = 'https://t.me/Dotherapy_support_bot';
export const TelegramSocialLink = 'https://t.me/do_therapy';
